export default __webpack_public_path__ + "static/aaron-bitmoji-81420cb633f5e0197ff97faf719e791c.png";